import React from "react";
import { Link } from "react-router-dom";


const Team = () => {

    const teamMembers = [
        { name: "Esther Howard", img: "assets/images/home_page_4/team/01.png" },
        { name: "Annette Black", img: "assets/images/home_page_4/team/02.png" },
        { name: "Devon Lane", img: "assets/images/home_page_4/team/03.png" },
        { name: "Jacob Jones", img: "assets/images/home_page_4/team/04.png" },
        { name: "Jerome Bell", img: "assets/images/home_page_4/team/05.png" },
        { name: "Dianne Russell", img: "assets/images/home_page_4/team/06.png" },
        { name: "Theresa Webb", img: "assets/images/home_page_4/team/07.png" },
        { name: "Darrell Steward", img: "assets/images/home_page_4/team/08.png" },
    ];

    return (
        <section id="team" className="team-main-block">
            <div className="container">
                <div className="row">
                    {teamMembers.map((member, index) => (
                        <div key={index} className="col-lg-3 col-md-6">
                            <div className="team-block">
                                <div className="team-img">
                                    <Link to="/TeamDetails" title="">
                                        <img src={member.img} className="img-fluid" alt={member.name} />
                                    </Link>
                                </div>
                                <div className="team-dtls text-center">
                                    <Link to="/TeamDetails" title="">
                                        <h3 className="team-dtl-name">{member.name}</h3>
                                    </Link>
                                    <p>Human Resource</p>
                                    <ul className="team-social-icon">
                                        <li className="facebook">
                                            <Link to="#" title="">
                                                <i className="flaticon-facebook" />
                                            </Link>
                                        </li>
                                        <li className="twitter">
                                            <Link to="#" title="">
                                                <i className="flaticon-twitter" />
                                            </Link>
                                        </li>
                                        <li className="google-plus">
                                            <Link to="#" title="">
                                                <i className="flaticon-google-plus" />
                                            </Link>
                                        </li>
                                        <li className="instagram">
                                            <Link to="#" title="">
                                                <i className="flaticon-instagram" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Team;
